import { signal } from '@preact/signals-react'
import type { Lobby } from './lobby.types'
import type { RoomMode } from '../../types'
import type { RoomInfo } from '../room/room.types'
import { getRoomNameFromURL, isSharedScreenModeFromRoomName, isOmniModeFromRoomName } from '../mode/urlInfo/urlInfo'

const ROOM_NAME_KEY = 'merels_roomName'

function readFromStorage(key: string): string {
  if (typeof window === 'undefined') return ''
  try {
    return sessionStorage.getItem(key) || ''
  } catch {
    return ''
  }
}

function getInitialRoomMode(): RoomMode {
  const urlRoomName = getRoomNameFromURL()

  if (urlRoomName && isOmniModeFromRoomName(urlRoomName)) {
    return 'room'
  }

  if (urlRoomName && isSharedScreenModeFromRoomName(urlRoomName)) {
    return 'room'
  }

  if (urlRoomName) return 'room'
  return 'room-selection'
}

function getInitialRoomInfo(): RoomInfo {
  const urlRoomName = getRoomNameFromURL()
  const savedRoomName = readFromStorage(ROOM_NAME_KEY)

  if (urlRoomName && isOmniModeFromRoomName(urlRoomName)) {
    // In Omni mode, local mates are generated by deps/mates/localMates (via deps/mates/omniMates).
    // Leave mateName empty so container can set it from the first local mate (e.g., "Alice").
    return {
      mateName: '',
      playerName: '',
      roomName: urlRoomName,
    }
  }

  if (urlRoomName && isSharedScreenModeFromRoomName(urlRoomName)) {
    const mateName = 'Player'
    return {
      mateName,
      playerName: mateName,
      roomName: urlRoomName,
    }
  }

  const roomName = urlRoomName || savedRoomName

  return { mateName: '', playerName: '', roomName }
}

export function makeLobby(): Lobby {
  const roomMode = signal<RoomMode>(getInitialRoomMode())
  const pendingRoomEntryAction = signal<(() => void | Promise<void>) | null>(null)
  const initialRoomInfo = getInitialRoomInfo()
  const initialIsLoadingRoomState = roomMode.value === 'room'
  const joinRoomName = signal<string>('')
  const newRoomName = signal<string>('')

  const urlRoomName = getRoomNameFromURL()
  if (urlRoomName) {
    joinRoomName.value = urlRoomName
  }

  return {
    initialRoomInfo,
    initialIsLoadingRoomState,
    roomMode,
    pendingRoomEntryAction,
    joinRoomName,
    newRoomName,
  }
}
